import { connect, MapStateToProps } from "react-redux";

import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { LOC_KEY_LOADING } from "../../locKeys";
import { LoadingMenuItemComponent, LoadingMenuItemComponentProps } from "../LoadingMenuItemComponent";

const mapStateToProps: MapStateToProps<LoadingMenuItemComponentProps, NoneOwnProps, IAppState> = (state) => ({
    text: getPrimaryText(state, LOC_KEY_LOADING),
});

export const LoadingMenuItem = connect(mapStateToProps)(LoadingMenuItemComponent);
